import { useEffect, useRef, useCallback, useState } from "react";
import { Tabs } from "antd";
import { useOutlet, useNavigate, useLocation, generatePath, useParams, matchPath } from "react-router";
import _ from "lodash";
import memoized from "nano-memoize";
import { useCommonStore } from "@/store/useCommonStore";
import Config from "@/config"

const getTabPath = (tab) => {
    return generatePath(tab.location.pathname, tab.params)
}

const generTabKey = memoized((location) => {
    return `${location.pathname}`;
});

const getTabMapKey = memoized((key) => {
    return key.substring(key.indexOf(',') + 1, key.length);
});

const TabRoute = () => {

    const menus = useCommonStore.use.menus().filter(item => { return item.Deleted == 'f' });

    const ele = useOutlet();

    const location = useLocation();

    const params = useParams();

    const navigate = useNavigate();

    const tabList = useRef(new Map());

    const [signal,setSignal] = useState(false);

    // 确保location 变化后,tab要计算下
    useEffect(() => {
        const curMenu = menus.find(menu => {
            if (!menu.Path) return false;
            const match = matchPath(Config.RoutePrefix + menu.Path, location.pathname);
            return !!match;
        });

        const tabname = curMenu?.Name ?? (ele?.props?.children?.props?.match?.route?.name) ?? "首页";
        const tabpath = curMenu?.Path ? Config.RoutePrefix + curMenu.Path : location.pathname;
        const tab = tabList.current.get(tabpath);

        const newTab = {
            name: tabname,
            key: generTabKey(location, tabpath),
            page: ele,
            location,
            params
        };

        if (tab) {
            if (tab.location.pathname !== location.pathname) {
                tabList.current.set(tabpath, newTab);
            }
        } else {
            tabList.current.set(tabpath, newTab);
            setSignal(!signal);
        }
    }, [location, menus, ele, signal]);

    const closeTab = useCallback((selectKey) => {
        if (tabList.current.size >= 2) {
            tabList.current.delete(getTabMapKey(selectKey));
            const nextKey = _.last(Array.from(tabList.current.keys()));
            navigate(getTabPath(tabList.current.get(nextKey)), { replace: true });
        }
    }, []);

    const selectTab = useCallback((selectKey) => {
        navigate(getTabPath(tabList.current.get(getTabMapKey(selectKey))), { replace: true });
    }, []);

    return (
        <Tabs className="bg-slate-100 h-full"
           size={"small"}
            activeKey={generTabKey(location)}
            onChange={(key) => selectTab(key)}
            // tabBarExtraContent={operations}
            tabBarStyle={{ background: "#fff",marginBottom:0 }}
            tabPosition="top"
            animated
            tabBarGutter={-1}
            hideAdd
            type="editable-card"
            onEdit={(targetKey) => closeTab(targetKey)}
            items={[...tabList.current.values()].map(item => ({
                label: item.name,
                key: item.key,
                children: item.page,
            }))}
        />
    )
}

export default TabRoute;
